<template>
  <w-icon-wrapper icon-name='work-circle-icon'>
    <path
      id='_62_Kreis_Icon'
      d='M68,2A10,10,0,1,1,58,12,10.011,10.011,0,0,1,68,2m0-2A12,12,0,1,0,80,12,12,12,0,0,0,68,0Z'
      data-name='62 Kreis_Icon'
      fill='currentColor'
      transform='translate(-56)'
    />
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconCircle' };
</script>
